"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CccisdCheckboxInput", {
  enumerable: true,
  get: function get() {
    return _CccisdCheckboxInput["default"];
  }
});
Object.defineProperty(exports, "CccisdColorPicker", {
  enumerable: true,
  get: function get() {
    return _CccisdColorPicker["default"];
  }
});
Object.defineProperty(exports, "CccisdCondition", {
  enumerable: true,
  get: function get() {
    return _CccisdCondition["default"];
  }
});
Object.defineProperty(exports, "CccisdDatepicker", {
  enumerable: true,
  get: function get() {
    return _CccisdDatepicker["default"];
  }
});
Object.defineProperty(exports, "CccisdFieldWrapper", {
  enumerable: true,
  get: function get() {
    return _CccisdFieldWrapper["default"];
  }
});
Object.defineProperty(exports, "CccisdInput", {
  enumerable: true,
  get: function get() {
    return _CccisdInput["default"];
  }
});
Object.defineProperty(exports, "CccisdPasswordInput", {
  enumerable: true,
  get: function get() {
    return _CccisdPasswordInput["default"];
  }
});
Object.defineProperty(exports, "CccisdSelect", {
  enumerable: true,
  get: function get() {
    return _CccisdSelect["default"];
  }
});
Object.defineProperty(exports, "CccisdTextarea", {
  enumerable: true,
  get: function get() {
    return _CccisdTextarea["default"];
  }
});
Object.defineProperty(exports, "CccisdToggle", {
  enumerable: true,
  get: function get() {
    return _CccisdToggle["default"];
  }
});
Object.defineProperty(exports, "CccisdWysiwyg", {
  enumerable: true,
  get: function get() {
    return _CccisdWysiwyg["default"];
  }
});
Object.defineProperty(exports, "ErrorMessage", {
  enumerable: true,
  get: function get() {
    return _formik.ErrorMessage;
  }
});
Object.defineProperty(exports, "FastField", {
  enumerable: true,
  get: function get() {
    return _formik.FastField;
  }
});
Object.defineProperty(exports, "Field", {
  enumerable: true,
  get: function get() {
    return _formik.Field;
  }
});
Object.defineProperty(exports, "FieldArray", {
  enumerable: true,
  get: function get() {
    return _formik.FieldArray;
  }
});
Object.defineProperty(exports, "Form", {
  enumerable: true,
  get: function get() {
    return _formik.Form;
  }
});
exports.Formik = void 0;
Object.defineProperty(exports, "FormikConsumer", {
  enumerable: true,
  get: function get() {
    return _formik.FormikConsumer;
  }
});
Object.defineProperty(exports, "FormikProvider", {
  enumerable: true,
  get: function get() {
    return _formik.FormikProvider;
  }
});
Object.defineProperty(exports, "connect", {
  enumerable: true,
  get: function get() {
    return _formik.connect;
  }
});
Object.defineProperty(exports, "getActiveElement", {
  enumerable: true,
  get: function get() {
    return _formik.getActiveElement;
  }
});
Object.defineProperty(exports, "getColor", {
  enumerable: true,
  get: function get() {
    return _cccisdColorPicker.getColor;
  }
});
Object.defineProperty(exports, "getIn", {
  enumerable: true,
  get: function get() {
    return _formik.getIn;
  }
});
Object.defineProperty(exports, "insert", {
  enumerable: true,
  get: function get() {
    return _formik.insert;
  }
});
Object.defineProperty(exports, "isEmptyChildren", {
  enumerable: true,
  get: function get() {
    return _formik.isEmptyChildren;
  }
});
Object.defineProperty(exports, "isFunction", {
  enumerable: true,
  get: function get() {
    return _formik.isFunction;
  }
});
Object.defineProperty(exports, "isInteger", {
  enumerable: true,
  get: function get() {
    return _formik.isInteger;
  }
});
Object.defineProperty(exports, "isNaN", {
  enumerable: true,
  get: function get() {
    return _formik.isNaN;
  }
});
Object.defineProperty(exports, "isObject", {
  enumerable: true,
  get: function get() {
    return _formik.isObject;
  }
});
Object.defineProperty(exports, "isPromise", {
  enumerable: true,
  get: function get() {
    return _formik.isPromise;
  }
});
Object.defineProperty(exports, "isString", {
  enumerable: true,
  get: function get() {
    return _formik.isString;
  }
});
Object.defineProperty(exports, "move", {
  enumerable: true,
  get: function get() {
    return _formik.move;
  }
});
Object.defineProperty(exports, "replace", {
  enumerable: true,
  get: function get() {
    return _formik.replace;
  }
});
Object.defineProperty(exports, "setIn", {
  enumerable: true,
  get: function get() {
    return _formik.setIn;
  }
});
Object.defineProperty(exports, "setNestedObjectValues", {
  enumerable: true,
  get: function get() {
    return _formik.setNestedObjectValues;
  }
});
Object.defineProperty(exports, "swap", {
  enumerable: true,
  get: function get() {
    return _formik.swap;
  }
});
Object.defineProperty(exports, "validateCccisdCondition", {
  enumerable: true,
  get: function get() {
    return _CccisdCondition.validateField;
  }
});
Object.defineProperty(exports, "validateYupSchema", {
  enumerable: true,
  get: function get() {
    return _formik.validateYupSchema;
  }
});
Object.defineProperty(exports, "withFormik", {
  enumerable: true,
  get: function get() {
    return _formik.withFormik;
  }
});
Object.defineProperty(exports, "yupToFormErrors", {
  enumerable: true,
  get: function get() {
    return _formik.yupToFormErrors;
  }
});
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formik = require("formik");
var _sync = _interopRequireDefault(require("./sync.js"));
var _CccisdCheckboxInput = _interopRequireDefault(require("./CccisdCheckboxInput"));
var _CccisdDatepicker = _interopRequireDefault(require("./CccisdDatepicker"));
var _CccisdFieldWrapper = _interopRequireDefault(require("./CccisdFieldWrapper"));
var _CccisdInput = _interopRequireDefault(require("./CccisdInput"));
var _CccisdPasswordInput = _interopRequireDefault(require("./CccisdPasswordInput"));
var _CccisdSelect = _interopRequireDefault(require("./CccisdSelect"));
var _CccisdTextarea = _interopRequireDefault(require("./CccisdTextarea"));
var _CccisdToggle = _interopRequireDefault(require("./CccisdToggle"));
var _CccisdWysiwyg = _interopRequireDefault(require("./CccisdWysiwyg"));
var _CccisdColorPicker = _interopRequireDefault(require("./CccisdColorPicker"));
var _CccisdCondition = _interopRequireWildcard(require("./CccisdCondition"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _Formik;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** 3C Formik wrapper */
var Formik = exports.Formik = (_Formik = /*#__PURE__*/function (_React$Component) {
  function Formik() {
    var _this;
    _classCallCheck(this, Formik);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Formik, [].concat(args));
    _defineProperty(_this, "onKeyDown", function (e) {
      e.nativeEvent.stopImmediatePropagation();
    });
    _defineProperty(_this, "prepareValues", function (values) {
      return _this.props.prepareValues ? _this.props.prepareValues(values) : values;
    });
    return _this;
  }
  _inherits(Formik, _React$Component);
  return _createClass(Formik, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var render = this.props.render;
      if (this.props.render && (this.props.onValidChange || this.props.onAnyChange)) {
        render = function render(args) {
          return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_sync["default"], _extends({}, args, {
            showErrorsImmediately: _this2.props.showErrorsImmediately,
            prepareValues: _this2.prepareValues,
            onValidChange: _this2.props.onValidChange,
            onAnyChange: _this2.props.onAnyChange
          })), _this2.props.render(args));
        };
      }
      var onSubmit = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, obj) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.props.onSubmit(values, obj);
              case 3:
                _context.next = 8;
                break;
              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                obj.setErrors(_context.t0);
              case 8:
                obj.setSubmitting(false);
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 5]]);
        }));
        return function onSubmit(_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
      return /*#__PURE__*/_react["default"].createElement("div", {
        onKeyDown: this.onKeyDown
      }, /*#__PURE__*/_react["default"].createElement(_formik.Formik, _extends({}, this.props, {
        render: render,
        onSubmit: onSubmit
      })));
    }
  }]);
}(_react["default"].Component), _defineProperty(_Formik, "propTypes", {
  onValidChange: _propTypes["default"].func,
  onAnyChange: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  render: _propTypes["default"].func,
  prepareValues: _propTypes["default"].func,
  showErrorsImmediately: _propTypes["default"].bool
}), _Formik);